// extracted by mini-css-extract-plugin
export default {"printButton":"print_printButton__sHOPh"};